import { render } from "./PLHelp.vue?vue&type=template&id=d3966d4a"
import script from "./PLHelp.vue?vue&type=script&lang=js"
export * from "./PLHelp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__